import { apiRequest } from '@/common/utils/request.common'
import {
  API_BASE_URL_STORE,
  HTTP_METHOD_GET,
} from '@/common/utils/request.const'
import { normalizeCheckPurchaseAction } from '@/common/normalize'

/**
 * 이용권 구매 전 동작 확인 API
 * @param {*} param { productId:string }
 * @returns {object | undefined} 정상호출시응답 {data: {actionType: 검증 결과(다음 액션 결정), requestProductInfo: 변경될 이용권 정보}}
 */
export const getCheckPurchaseAction = async ({ productId }) => {
  if (!productId) {
    return
  }
  const url = `${API_BASE_URL_STORE}/v1/pass/check-purchase-action?product_id=${productId}`
  try {
    const response = await apiRequest({
      url,
      method: HTTP_METHOD_GET,
    })

    response.data = normalizeCheckPurchaseAction(response?.data)
    return response
  } catch (error) {
    return {
      error: error.response,
    }
  }
}
